import { inject, Provider } from '@angular/core';
import { PracticeActivityCompletionData, PracticeActivityService } from '@examdojo/practice-activity';
import {
  ACTIVITY_COMPLETION_DATA_PROVIDER,
  ActivityCompletionData,
  ActivityCompletionDataProvider,
  QUESTION_ATTEMPT_FULLSCREEN_FLOW_CONFIG,
} from '@examdojo/question';
import { isNotNullish } from '@examdojo/util/nullish';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs';
import { TopicPracticeV2Service } from '../topic-practice-v2.service';

function mapToActivityCompletionData(data: PracticeActivityCompletionData): ActivityCompletionData {
  return {
    totalMarks: data.total_marks,
    awardedMarks: data.awarded_marks,
    timeSpentMs: data.time_spent_ms,
    pacePerMark: data.pace_per_mark,
    paceBoundaries: data.pace_boundaries,
    paceChartIndex: data.pace_chart_index,
  };
}

export function provideFullscreenFlowConfig(): Provider[] {
  return [
    {
      provide: ACTIVITY_COMPLETION_DATA_PROVIDER,
      useFactory: (): ActivityCompletionDataProvider => {
        const topicPracticeService = inject(TopicPracticeV2Service);
        const practiceActivityService = inject(PracticeActivityService);

        return {
          completionData$: topicPracticeService.inProgressPracticeActivity$.pipe(
            map((activity) => activity?.id),
            filter(isNotNullish),
            distinctUntilChanged(),
            switchMap((activityId) => practiceActivityService.getPracticeActivityCompletionData(activityId)),
            map(mapToActivityCompletionData),
          ),
          nextButtonLabelKey$: topicPracticeService.isMultiQuestionActivity$.pipe(
            map((isMulti) => (isMulti ? 'close' : 'examdojo.grading.review_results')),
          ),
        };
      },
    },
    {
      provide: QUESTION_ATTEMPT_FULLSCREEN_FLOW_CONFIG,
      useFactory: () => ({
        skipFullscreenFlow$: inject(TopicPracticeV2Service).isMultiQuestionActivity$,
      }),
    },
  ];
}
